import { createContext, useState, useEffect, useMemo } from 'react';

export type GlobalLoadingContextType = {
  loading: boolean;
  setLoadingAuthentication: (loading: boolean) => void;
};

interface IProps {
  children: JSX.Element;
}

export const GlobalLoadingContext = createContext<GlobalLoadingContextType>({
  loading: true,
  setLoadingAuthentication: () => {},
});

export const GlobalLoadingContextProvider = ({ children }: IProps): JSX.Element => {
  const [loadingAuthentication, setLoadingAuthentication] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const value = useMemo(
    () => ({ loading, setLoadingAuthentication }),
    [loading, setLoadingAuthentication]
  );

  useEffect(() => {
    setLoading(loadingAuthentication);
  }, [loadingAuthentication]);

  return <GlobalLoadingContext.Provider value={value}>{children}</GlobalLoadingContext.Provider>;
};
